// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import "firebase/firestore";

// QUIZ DATA
const cmsApp = initializeApp(
  {
    apiKey: "AIzaSyBtVBqx1jD50QhkBqV1Jb9A58zb7MtngiU",
    authDomain: "financial-fitness-cms.firebaseapp.com",
    projectId: "financial-fitness-cms",
    storageBucket: "financial-fitness-cms.appspot.com",
    messagingSenderId: "175949551885",
    appId: "1:175949551885:web:e331c4cb3783bcc5bc7844",
  },
  "cmsApp"
);
export const cmsDb = getFirestore(cmsApp);
